import { fieldOptionsFactory, IFormSchema } from 'spark-forms';
import { Day } from '../../../../Entities/Recurrence/Day';
import { DayOfWeek } from '../../../../Entities/Recurrence/DayOfWeek';
import { Month } from '../../../../Entities/Recurrence/Month';
import { Ordinal } from '../../../../Entities/Recurrence/Ordinal';
import { RecurrenceFrequency } from '../../../../Entities/Recurrence/RecurrenceFrequency';
import { DropdownOptionEx } from '../../../../Utilities/DropdownOptionEx';
import { IRecurrenceRule } from './IRecurrenceRule';
import { translate } from '../../../../Locales/i18n/localizationService';

export const recurrenceRuleSchema: IFormSchema<IRecurrenceRule> = {
    fields: {
        frequency: fieldOptionsFactory.predefinedArray({
            displayName: translate.t("Common.Frequency"),
            description: translate.t("RecurrenceRule.FrequencyDescription"),
            config: {
                predefinedOptions: { options: DropdownOptionEx.enumToDropdownOptionsWithoutSome<RecurrenceFrequency>(RecurrenceFrequency, [1]) },
            },
            // onChanged: item => {
            // 	item.day = null;
            // 	item.dayOfWeek = null;
            // 	item.daysOfWeek = null;
            // 	item.months = null;
            // 	item.ordinalWeek = null;
            // 	return null;
            // }
        }),
        skip: fieldOptionsFactory.predefinedArray({
            displayName: translate.t("RecurrenceRule.Skip"),
            description: translate.t("RecurrenceRule.SkipDescription"),
            config: {
                predefinedOptions: {
                    options: DropdownOptionEx.toDropdownOptions(
                        Array.from({ length: 10 }, (v, k) => k + 1),
                        _ => _,
                        _ => _ + '',
                    ),
                },
            },
        }),
        months: fieldOptionsFactory.predefinedArray({
            displayName: translate.t("RecurrenceRule.Months"),
            description: translate.t("RecurrenceRule.MonthsDescription"),
            hide: (obj: IRecurrenceRule) => obj.frequency !== RecurrenceFrequency.Year,
            config: { multiSelect: true, predefinedOptions: { options: DropdownOptionEx.enumToDropdownOptions<Month>(Month) } },
        }),
        ordinalWeek: fieldOptionsFactory.predefinedArray({
            displayName: translate.t("RecurrenceRule.OrdinalWeek"),
            description: translate.t("RecurrenceRule.OrdinalWeekDescription"),
            config: { predefinedOptions: { options: DropdownOptionEx.enumToDropdownOptionsAddEmptyEntry<Ordinal>(Ordinal, null, 'Not used') } },
            hide: (obj: IRecurrenceRule) => (obj.frequency !== RecurrenceFrequency.Year && obj.frequency !== RecurrenceFrequency.Month) || obj.day != null,
        }),
        day: fieldOptionsFactory.predefinedArray({
            displayName: translate.t("RecurrenceRule.Day"),
            description: translate.t("RecurrenceRule.DayDescription"),
            config: {
                predefinedOptions: {
                    options: DropdownOptionEx.toDropdownOptionsAddEmptyEntry(
                        Array.from({ length: 31 }, (v, k) => k + 1),
                        _ => _,
                        _ => _ + '',
                        null,
                        null,
                        'Not used',
                    ),
                },
            },
            hide: (obj: IRecurrenceRule) =>
                obj.daysOfWeek?.length > 0 ||
                (obj.frequency !== RecurrenceFrequency.Year && obj.frequency !== RecurrenceFrequency.Month) ||
                obj.dayOfWeek != null,
            validation: {
                validationMark: 'required',
                validationRule: async (item: IRecurrenceRule) => {
                    return validateDay(item) ? undefined : translate.t("RecurrenceRule.DayValidation");
                },
            },
        }),
        daysOfWeek: fieldOptionsFactory.predefinedArray({
            displayName: translate.t("RecurrenceRule.DaysOfWeek"),
            description: translate.t("RecurrenceRule.DaysOfWeekDescription"),
            config: { multiSelect: true, predefinedOptions: { options: DropdownOptionEx.enumToDropdownOptions<Day>(Day) } },
            hide: (obj: IRecurrenceRule) => obj.frequency !== RecurrenceFrequency.Week
        }),
        dayOfWeek: fieldOptionsFactory.predefinedArray({
            displayName: translate.t("RecurrenceRule.DayOfWeek"),
            description: translate.t("RecurrenceRule.DayOfWeekValidation"),
            config: { predefinedOptions: { options: DropdownOptionEx.enumToDropdownOptionsAddEmptyEntry<DayOfWeek>(DayOfWeek, null, 'Not used') } },
            hide: (obj: IRecurrenceRule) => obj.frequency === RecurrenceFrequency.Week || obj.day != null,
            validation: {
                validationRule: async item => {
                    if (item.dayOfWeek != null && item.ordinalWeek == null) {
                        return translate.t("RecurrenceRule.DayOfWeekValidation");
                    }
                    return null;
                },
            },
        }),
        activeFrom: fieldOptionsFactory.date({
            displayName: translate.t("RecurrenceRule.ActiveFrom"),
            description: translate.t("RecurrenceRule.ActiveFromDescription"),
            validation: { 
				validationMark: 'required',
				validationRule: async item => {
					if (!item.activeFrom) {
						return translate.t("RecurrenceRule.ActiveFromValidation");
					}
					return null;
				}
			},
        }),
        activeTo: fieldOptionsFactory.date({ displayName: translate.t("RecurrenceRule.ActiveTo"), description: translate.t("RecurrenceRule.ActiveToDescription") }),
    },
};

const validateDay = (rule: IRecurrenceRule): boolean => {
    if (rule.frequency === RecurrenceFrequency.Year) {
        if (rule.day == null) {
            return true;
        }
        if (rule.months == null && !rule.ordinalWeek) {
            return false;
        }
    }
    return true;
};
